// const host = window.location.origin;
let menu = [

  {
    path: '/',
    name: 'home',
    hidden: true,
    meta: {
      title: '首页',
      icon: 'el-icon-s-platform'
    },
    children: [
      {
        path: '/home',
        name: 'home',
        hidden: true,
        meta: {
          title: '首页',
          icon: 'iconfont icon-shouye'
        }
      }
    ]
  },
  {
    path: '/newApplicationForm',
    name: 'newApplicationForm',
    hidden: true,
    alwaysShow: true,
    meta: {
      title: '新建申请',
      icon: 'iconfont icon-xinjianshenqing'
    },
    children: [
      {
        path: '/activityApplication',
        name: 'activityApplication',
        hidden: true,
        meta: {
          title: '活动申请',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/quickApplicationForm',
        name: 'quickApplicationForm',
        hidden: true,
        meta: {
          title: '快捷申请',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/industryReportApplication',
        name: 'industryReportApplication',
        hidden: true,
        meta: {
          title: '行业报备申请',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/regionReportApplication',
        name: 'regionReportApplication',
        hidden: true,
        meta: {
          title: '区域报备申请',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/reportApplication',
        name: 'reportApplication',
        hidden: true,
        meta: {
          title: '报备申请',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/qdApplication',
        name: 'qdApplication',
        hidden: true,
        meta: {
          title: '渠道申请',
          icon: 'iconfont icon-erji-Icon'
        }
      }
    ]
  },
  {
    path: '/activitieList',
    name: 'activitieList',
    hidden: true,
    alwaysShow: true,
    meta: {
      title: '活动列表',
      icon: 'iconfont icon-huodongliebiao'
    },
    children: [
      {
        path: '/activityQuery',
        name: 'activityQuery',
        hidden: true,
        meta: {
          title: '活动申请列表',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/reportList',
        name: 'reportList',
        hidden: true,
        meta: {
          title: '活动报备列表',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/industryReportList',
        name: 'industryReportList',
        hidden: true,
        meta: {
          title: '行业报备列表',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/regionReportList',
        name: 'regionReportList',
        hidden: true,
        meta: {
          title: '区域报备列表',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/drafts',
        name: 'drafts',
        hidden: true,
        meta: {
          title: '草稿箱',
          icon: 'iconfont icon-erji-Icon'
        }
      }
    ]
  },
  {
    path: '/approvalCenter',
    name: 'approvalCenter',
    hidden: true,
    alwaysShow: true,
    meta: {
      title: '审批中心',
      icon: 'iconfont icon-shenpizhongxin'
    },
    children: [
      {
        path: '/pendingApproval',
        name: 'pendingApproval',
        hidden: true,
        meta: {
          title: '待审批',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/alreadyApproved',
        name: 'alreadyApproved',
        hidden: true,
        meta: {
          title: '已审批',
          icon: 'iconfont icon-erji-Icon'
        }
      }
    ]
  },
  {
    path: '/annualMarketingPlan',
    name: 'annualMarketingPlan',
    hidden: true,
    meta: {
      title: '年度营销规划',
      icon: 'el-icon-s-platform'
    },
    children: [
      {
        path: '/annualMarketingPlan',
        name: 'annualMarketingPlan',
        hidden: true,
        meta: {
          title: '年度营销规划',
          icon: 'iconfont icon-huodongliebiao'
        }
      }
    ]
  },
  {
    path: '/cluePool',
    name: 'cluePool',
    hidden: true,
    alwaysShow: true,
    meta: {
      title: '线索池',
      icon: 'iconfont icon-xiansuochi'
    },
    children: [
      {
        path: '/cluePoolList',
        name: 'cluePoolList',
        hidden: true,
        meta: {
          title: '线索池列表',
          icon: 'iconfont icon-erji-Icon'
        }
      }
    ]
  },
  {
    path: '/privateSeaPool',
    name: 'privateSeaPool',
    hidden: true,
    alwaysShow: true,
    meta: {
      title: '私海池',
      icon: 'iconfont icon-sihaichi'
    },
    children: [
      {
        path: '/waitingProcessing',
        name: 'waitingProcessing',
        hidden: true,
        meta: {
          title: '待处理',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/selfFollow',
        name: 'selfFollow',
        hidden: true,
        meta: {
          title: '自行跟进',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/completedProcessing',
        name: 'completedProcessing',
        hidden: true,
        meta: {
          title: '已处理',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/clueSuspend',
        name: 'clueSuspend',
        hidden: true,
        meta: {
          title: '挂起',
          icon: 'iconfont icon-erji-Icon'
        }
      }
    ]
  },
  {
    path: '/helpDocumentation',
    name: 'helpDocumentation',
    hidden: true,
    meta: {
      title: '帮助文档',
      icon: 'iconfont icon-bangzhuwendang'
    }
  },
  {
    path: '/backStageManagement',
    name: 'backStageManagement',
    hidden: true,
    alwaysShow: true,
    meta: {
      title: '后台管理',
      icon: 'iconfont icon-houtaiguanli'
    },
    children: [
      {
        path: '/accountManagement',
        name: 'accountManagement',
        hidden: true,
        meta: {
          title: '对公账号管理',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/activityDataExport',
        name: 'activityDataExport',
        hidden: true,
        meta: {
          title: '活动数据导出',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/budgetPerformance',
        name: 'budgetPerformance',
        hidden: true,
        meta: {
          title: '预算执行情况',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/budgetPerformancePermission',
        name: 'budgetPerformancePermission',
        hidden: true,
        meta: {
          title: '预算执行情况权限管理',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/expensesJurManagement',
        name: 'expensesJurManagement',
        hidden: true,
        meta: {
          title: '费用申请权限管理',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/approvalManagement',
        name: 'approvalManagement',
        hidden: true,
        meta: {
          title: '审批人管理',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/transferOrder',
        name: 'transferOrder',
        hidden: true,
        meta: {
          title: '调单',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/channelAccountManagement',
        name: 'channelAccountManagement',
        hidden: true,
        meta: {
          title: '渠道账号管理',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/templateActivityManagement',
        name: 'templateActivityManagement',
        hidden: true,
        meta: {
          title: '模板活动管理',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/ruleConfiguration',
        name: 'ruleConfiguration',
        hidden: true,
        meta: {
          title: '活动分层配置',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/hqActivityManagement',
        name: 'hqActivityManagement',
        hidden: true,
        meta: {
          title: '总部活动管理',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/businessUnitManagement',
        name: 'businessUnitManagement',
        hidden: true,
        meta: {
          title: '业务单元管理',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/roleManagement',
        name: 'roleManagement',
        hidden: true,
        meta: {
          title: '角色管理',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/authorityManagement',
        name: 'authorityManagement',
        hidden: true,
        meta: {
          title: '权限管理',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/cluePoolManagement',
        name: 'cluePoolManagement',
        hidden: true,
        meta: {
          title: '线索池管理',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/privateSeaPoolManagement',
        name: 'privateSeaPoolManagement',
        hidden: true,
        meta: {
          title: '私海池管理',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/clueCirculationRecord',
        name: 'clueCirculationRecord',
        hidden: true,
        meta: {
          title: '线索流转记录',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/clueStaffCircConfigure',
        name: 'clueStaffCircConfigure',
        hidden: true,
        meta: {
          title: '线索审核人员配置',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/industryManagement',
        name: 'industryManagement',
        hidden: true,
        meta: {
          title: '行业管理',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/documentViewPermission',
        name: 'documentViewPermission',
        hidden: true,
        meta: {
          title: '活动单据查看权限',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: '/activityBase',
        name: 'activityBase',
        hidden: true,
        meta: {
          title: '活动基地',
          icon: 'iconfont icon-erji-Icon'
        }
      }
    ]
  },
  {
    path: '/relatedLinks',
    name: 'relatedLinks',
    hidden: true,
    alwaysShow: true,
    meta: {
      title: '相关系统',
      icon: 'iconfont icon-xiangguanxitong'
    },
    children: [
      {
        path: 'https://app.convertlab.com/index.html',
        name: 'HT',
        hidden: true,
        meta: {
          title: '会腾',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: 'https://ruijie.going-link.com/oauth/login/bykey',
        name: 'giftBank',
        hidden: true,
        meta: {
          title: '礼品库',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: 'https://eps.ruijie.com.cn:8001/Office?math=1958441800',
        name: 'nonMining',
        hidden: true,
        meta: {
          title: '非采系统',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: 'http://exp2012.ruijie.com.cn/pages/index.aspx',
        name: 'costSystem',
        hidden: true,
        meta: {
          title: '新版费用系统',
          icon: 'iconfont icon-erji-Icon'
        }
      },
      {
        path: 'http://ruijiebi.ruijie.com.cn/webroot/decision?rjl=oa',
        name: 'ruijieBi',
        hidden: true,
        meta: {
          title: 'BI智能分析平台',
          icon: 'iconfont icon-erji-Icon'
        }
      }
    ]
  }
];

export default menu;
